import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {IContent} from '../administration/contents/contents';
import {MessengerService} from '../messenger/messenger.service';
import {BreadcrumbsService} from '../shared/components/breadcrumbs/breadcrumbs.service';
import {HomeService} from './home.service';

@Component({
    selector: 'kkk-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
    slides: IContent[];
    articles: IContent[];
    events: any[];
    recommended: any[];

    constructor(
        private _service: HomeService,
        private _breadcrumbs: BreadcrumbsService,
        private _messenger: MessengerService,
    ) {
    }

    ngOnInit() {
        this._breadcrumbs.reset().setTitle('Kezdőlap');
        this._service.slides().subscribe(
            slides => this.slides = slides.map(s => {
                if (s.forward && s.forward.startsWith('/')) {
                    s.routerLink = [s.forward];
                }
                return s;
            }),
            this._messenger.handleError
        );
        this._service.articles().subscribe(
            articles => this.articles = articles,
            this._messenger.handleError
        );
        // this.loadEvents();
        this.loadRecommended();
    }

    // private loadEvents() {
    //     this.events = [
    //         {
    //             day: 11,
    //             month: 'Szeptember',
    //             location: 'KKK Közösségi ház',
    //             time: '18:00 - 20:00',
    //             title: 'Tanuljunk az imáról!'
    //         },
    //         {
    //             day: 15,
    //             month: 'Szeptember',
    //             location: 'Több helyszín',
    //             time: '18:00 - 21:00',
    //             title: 'Házicsoport'
    //         },
    //         {
    //             day: 17,
    //             month: 'Szeptember',
    //             location: 'Kossuth tér',
    //             time: '16:00 - 18:00',
    //             title: 'Közös Istentisztelet'
    //         },
    //         {
    //             day: 19,
    //             month: 'Szeptember',
    //             location: 'KKK Közösségi ház',
    //             time: '18:00 - 20:00',
    //             title: 'Tanuljunk az imáról!'
    //         },
    //         {
    //             day: 22,
    //             month: 'Szeptember',
    //             location: 'Több helyszín',
    //             time: '18:00 - 21:00',
    //             title: 'Házicsoport'
    //         },
    //     ];
    // }

    private loadRecommended() {
        this.recommended = [
            // {
            //     image: `/assets/sheep1.jpg`,
            //     title: 'Barátaink',
            //     short: 'Jó kapcsolatot ápolunk sok más keresztény gyülekezettel és szervezettel.',
            //     route: ['/barataink']
            // },
            {
                image: `/assets/sdg.jpg`,
                title: 'Tábor 2017',
                short: 'Elérhetőek a 2017-es nyári tábor felvételei. Hallgassátok őket! =)',
                forward: 'http://kapkerkoz.hu/nyt2017/'
            },
        ];
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/home/home.component.ts